// extracted by mini-css-extract-plugin
export default {"contenedor-informacion":"AsuntosLegales_contenedor-informacion__swzai","contenedor-informacion-general-empresa":"AsuntosLegales_contenedor-informacion-general-empresa__4VQjp"};